<template>
    <section>
        <div class="px-4 py-6 mx-auto max-w-5xl lg:py-16 xl:px-0">
            <!-- Main Heading -->
            <h3
                class="mb-4 text-2xl leading-none text-center lg:mb-8 sm:text-3xl md:text-32 font-ww-bold xl:px-12"
                v-html="mainHeading">
            </h3>
            <!-- Introduction Text -->
            <div class="mb-8 text-sm text-left sm:text-base lg:text-lg font-ww-regular" v-html="introText">
            </div>
            <!-- Ingredients List -->
            <ul class="grid gap-y-8 px-6 mb-8 text-base list-disc md:px-12 md:gap-x-16 md:gap-y-16 md:grid-cols-2 md:text-lg">
                <li v-for="ingredient in ingredients" :key="ingredient.id" class="">
                    <h3 class="text-base font-ww-bold xl:text-17">{{ ingredient.title }}</h3>
                    <div class="text-sm sm:text-base !leading-5 font-ww-regular xl:text-17">
                        {{ ingredient.description }}
                    </div>
                    <a :href="ingredient.link" target="_blank"
                        class="space-x-2 cursor-pointer">
                        <span class="underline !leading-5 -mt-1 sm:text-base font-ww-regular lg:text-17 text-sm">{{ ingredient.reference }}</span> 
                        <svg class="inline-block" width="15" height="20"
                            viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.364 5.1864L9.89404 0.71645C9.7897 0.612074 9.64729 0.552734 9.49888 0.552734H1.67627C0.751976 0.552734 0 1.30471 0 2.22901V17.9487C0 18.873 0.751976 19.625 1.67627 19.625H12.8514C13.7757 19.625 14.5277 18.873 14.5277 17.9487V5.58155C14.5277 5.4292 14.4637 5.28612 14.364 5.1864ZM10.0576 2.46045L12.62 5.0228H10.6164C10.3083 5.0228 10.0576 4.77214 10.0576 4.46404V2.46045ZM12.8514 18.5075H1.67627C1.36817 18.5075 1.11752 18.2568 1.11752 17.9487V2.22901C1.11752 1.92091 1.36817 1.67025 1.67627 1.67025H8.94012V4.46404C8.94012 5.38834 9.6921 6.14031 10.6164 6.14031H13.4102V17.9487C13.4102 18.2568 13.1595 18.5075 12.8514 18.5075Z"
                                fill="black" />
                            <path
                                d="M10.6154 8.44922H3.91032C3.60174 8.44922 3.35156 8.69939 3.35156 9.00798C3.35156 9.31656 3.60174 9.56673 3.91032 9.56673H10.6154C10.924 9.56673 11.1742 9.31656 11.1742 9.00798C11.1742 8.69939 10.924 8.44922 10.6154 8.44922Z"
                                fill="black" />
                            <path
                                d="M10.6154 10.6855H3.91032C3.60174 10.6855 3.35156 10.9357 3.35156 11.2443C3.35156 11.5529 3.60174 11.8031 3.91032 11.8031H10.6154C10.924 11.8031 11.1742 11.5529 11.1742 11.2443C11.1742 10.9357 10.924 10.6855 10.6154 10.6855Z"
                                fill="black" />
                            <path
                                d="M10.6154 12.9199H3.91032C3.60174 12.9199 3.35156 13.1701 3.35156 13.4787C3.35156 13.7873 3.60174 14.0374 3.91032 14.0374H10.6154C10.924 14.0374 11.1742 13.7873 11.1742 13.4787C11.1742 13.1701 10.924 12.9199 10.6154 12.9199Z"
                                fill="black" />
                            <path
                                d="M8.38038 15.1543H3.91032C3.60174 15.1543 3.35156 15.4045 3.35156 15.7131C3.35156 16.0216 3.60174 16.2718 3.91032 16.2718H8.38038C8.68897 16.2718 8.93914 16.0216 8.93914 15.7131C8.93914 15.4045 8.68897 15.1543 8.38038 15.1543Z"
                                fill="black" />
                        </svg>
                    </a>
                </li>
                <li class="list-none marker:hidden">
                    <div class="p-5 bg-[#F1FBC8] border border-[#C4E538]">
                        <div class="flex gap-x-4 items-start">
                          <div class="mt-1">
                            <svg width="25" height="45" viewBox="0 0 25 45" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.9199 15.45C24.7731 15.1501 24.5529 15 24.2593 15H15.5979L24.186 1.125C24.3328 0.9 24.3328 0.600029 24.186 0.375029C24.0391 0.150029 23.8189 0 23.5253 0H11.781C11.4875 0 11.2673 0.150029 11.1204 0.375029L0.110125 22.875C-0.0367082 23.1 -0.0367082 23.4 0.110125 23.625C0.256957 23.85 0.550537 24 0.770743 24H8.33112L0.110125 44.025C-0.0367082 44.325 0.110125 44.7 0.403704 44.925C0.477077 45 0.62391 45 0.770743 45C0.990949 45 1.21115 44.925 1.35799 44.775L24.8467 16.275C24.9934 16.05 25.0668 15.75 24.9199 15.45ZM3.33976 39.975L10.0928 23.4751C10.1661 23.2501 10.1661 23.0251 10.0194 22.8001C9.87256 22.65 9.65236 22.5001 9.43215 22.5001H1.94515L12.2215 1.50003H22.2041L13.5427 15.375C13.3959 15.6 13.3959 15.8999 13.5427 16.1249C13.6895 16.3499 13.9097 16.5 14.2033 16.5H22.718L3.33976 39.975Z" fill="black"/>
</svg>
                          </div>
                            <div class="font-ww-regular !leading-5 xl:text-17 sm:text-base text-sm" v-html="highlightBoxText">
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- Order Button -->
            <div class="mt-8 text-center md:mt-16">
                <button
                    @click="scrollTo(buttonHref,'bottom')"
                    class="inline-flex justify-center items-center px-8 py-4 text-lg font-bold text-white rounded-full transition-colors duration-200 lg:w-6/12 font-ww-medium btn-red hover:bg-red-600">
                    {{ buttonText }}
                    <svg  class="ml-2 w-5 h-5" width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3007 0.50283C13.2069 0.595793 13.1325 0.706394 13.0818 0.828253C13.031 0.950112 13.0049 1.08082 13.0049 1.21283C13.0049 1.34484 13.031 1.47555 13.0818 1.59741C13.1325 1.71927 13.2069 1.82987 13.3007 1.92283L17.9007 6.52283L1.5 6.33529C1.23478 6.33529 0.98043 6.44065 0.792893 6.62819C0.605357 6.81572 0.5 7.07008 0.5 7.33529C0.5 7.60051 0.605357 7.85486 0.792893 8.0424C0.98043 8.22994 1.23478 8.33529 1.5 8.33529L17.8807 8.52283L13.3007 13.0928C13.1144 13.2802 13.0099 13.5336 13.0099 13.7978C13.0099 14.062 13.1144 14.3155 13.3007 14.5028C13.488 14.6891 13.7415 14.7936 14.0057 14.7936C14.2699 14.7936 14.5233 14.6891 14.7107 14.5028L21.0707 8.14283C21.1563 8.0607 21.2244 7.96211 21.2709 7.85299C21.3174 7.74386 21.3414 7.62646 21.3414 7.50783C21.3414 7.3892 21.3174 7.2718 21.2709 7.16267C21.2244 7.05355 21.1563 6.95496 21.0707 6.87283L14.7207 0.50283C14.6277 0.409101 14.5171 0.334707 14.3952 0.283938C14.2734 0.23317 14.1427 0.207031 14.0107 0.207031C13.8787 0.207031 13.748 0.23317 13.6261 0.283938C13.5042 0.334707 13.3936 0.409101 13.3007 0.50283Z" fill="white"/>
</svg>
                </button>
            </div>
        </div>
    </section>
</template>

<script setup>
defineProps({
  mainHeading: {
    type: String,
    default: 'Backed by Science, Proven in the Real World'
  },
  introText: {
    type: String,
    default: 'Each ingredient in Mindflow is backed by real clinical research showing its ability to improve cognitive performance, focus, memory, or energy—without the downside of overstimulation.<br><br>Here\'s just a glimpse of the science behind Mindflow:'
  },
  ingredients: {
    type: Array,
    default: () => [
      {
        id: 1,
        title: "Caffeine + Cognitive Performance*",
        description: "A 2020 study published in Frontiers in Psychology found that low doses of caffeine improve executive function, mental flexibility, and task-switching ability by increasing activity in the prefrontal cortex.",
        reference: "Reference",
        link: "https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2020.01393/full"
      },
      {
        id: 2,
        title: "Chaga + Cognitive Inflammation Reduction*",
        description: "Chaga has shown powerful antioxidant and anti-inflammatory properties, which may support focus by reducing oxidative stress in the brain.",
        reference: "Reference: Park et al., Journal of Ethnopharmacology, 2005",
        link: "https://pubmed.ncbi.nlm.nih.gov/15707780/"
      },
      {
        id: 3,
        title: "Alpha GPC + Focus & Memory*",
        description: "Alpha GPC (used in Mindflow at a full 300mg dose) has been shown to enhance memory and learning by boosting acetylcholine levels in the brain.",
        reference: "Reference: McDaniel et al., Clinical Therapeutics, 2003",
        link: "https://pubmed.ncbi.nlm.nih.gov/12926662/"
      },
      {
        id: 4,
        title: "Lion's Mane + Neurogenesis*",
        description: "Lion's Mane mushroom stimulates Nerve Growth Factor (NGF), which supports brain cell regeneration and cognitive function.",
        reference: "Reference: Mori et al., Biomedical Research, 2009",
        link: "https://pubmed.ncbi.nlm.nih.gov/19252283/"
      },
      {
        id: 5,
        title: "Cognilift* + Brain-Derived Neurotrophic Factor (BDNF)*",
        description: "Cognilift, a patented botanical extract, has been clinically shown to increase BDNF—an essential protein for learning, memory, and neuroplasticity.",
        reference: "Reference: Nutraceuticals Clinical Report (2015)",
        link: "#"
      }
    ]
  },
  highlightBoxText: {
    type: String,
    default: 'Mindflow doesn\'t just feel great—it works because the science works. Every ingredient is dosed for real-world effects, not fairy dust.'
  },
  buttonText: {
    type: String,
    default: 'ORDER NOW'
  },
  buttonHref: {
    type: String,
    default: 'products'
  }
})

defineBuilderComponent({
    friendlyName: 'Info List With Sources',
    canHaveChildren: false,
    inputs: [
        {
            name: 'mainHeading',
            type: 'richText',
            defaultValue: 'Backed by Science, Proven in the Real World'
        },
        {
            name: 'introText',
            type: 'richText',
            defaultValue: 'Each ingredient in Mindflow is backed by real clinical research showing its ability to improve cognitive performance, focus, memory, or energy—without the downside of overstimulation.<br><br>Here\'s just a glimpse of the science behind Mindflow:'
        },
        {
            name: 'ingredients',
            type: 'list',
            subFields: [
                {
                    name: 'id',
                    type: 'number',
                    defaultValue: 1
                },
                {
                    name: 'title',
                    type: 'text',
                    defaultValue: ''
                },
                {
                    name: 'description',
                    type: 'richText',
                    defaultValue: ''
                },
                {
                    name: 'reference',
                    type: 'text',
                    defaultValue: 'Reference'
                },
                {
                    name: 'link',
                    type: 'text',
                    defaultValue: '#'
                }
            ],
            defaultValue: [
                {
                    id: 1,
                    title: "Caffeine + Cognitive Performance*",
                    description: "A 2020 study published in Frontiers in Psychology found that low doses of caffeine improve executive function, mental flexibility, and task-switching ability by increasing activity in the prefrontal cortex.",
                    reference: "Reference",
                    link: "https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2020.01393/full"
                },
                {
                    id: 2,
                    title: "Chaga + Cognitive Inflammation Reduction*",
                    description: "Chaga has shown powerful antioxidant and anti-inflammatory properties, which may support focus by reducing oxidative stress in the brain.",
                    reference: "Reference: Park et al., Journal of Ethnopharmacology, 2005",
                    link: "https://pubmed.ncbi.nlm.nih.gov/15707780/"
                },
                {
                    id: 3,
                    title: "Alpha GPC + Focus & Memory*",
                    description: "Alpha GPC (used in Mindflow at a full 300mg dose) has been shown to enhance memory and learning by boosting acetylcholine levels in the brain.",
                    reference: "Reference: McDaniel et al., Clinical Therapeutics, 2003",
                    link: "https://pubmed.ncbi.nlm.nih.gov/12926662/"
                },
                {
                    id: 4,
                    title: "Lion's Mane + Neurogenesis*",
                    description: "Lion's Mane mushroom stimulates Nerve Growth Factor (NGF), which supports brain cell regeneration and cognitive function.",
                    reference: "Reference: Mori et al., Biomedical Research, 2009",
                    link: "https://pubmed.ncbi.nlm.nih.gov/19252283/"
                },
                {
                    id: 5,
                    title: "Cognilift* + Brain-Derived Neurotrophic Factor (BDNF)*",
                    description: "Cognilift, a patented botanical extract, has been clinically shown to increase BDNF—an essential protein for learning, memory, and neuroplasticity.",
                    reference: "Reference: Nutraceuticals Clinical Report (2015)",
                    link: "#"
                }
            ]
        },
        {
            name: 'highlightBoxText',
            type: 'richText',
            defaultValue: 'Mindflow doesn\'t just feel great—it works because the science works. Every ingredient is dosed for real-world effects, not fairy dust.'
        },
        {
            name: 'buttonText',
            type: 'text',
            defaultValue: 'ORDER NOW'
        },
        {
            name: 'buttonHref',
            type: 'text',
            defaultValue: 'products'
        }
    ]
})
</script>

<style scoped></style>